const FlowType = {
    Performance: {
        name: "performace", 
        title: "Performance Summary",
        metric1Name: "Emails Opened", 
        metric1Val: "4.72k",
        metric2Name: "Click Through Rate",
        metric2Val: "4.5%",
        dataSource: "Something"

    },
    Conversion: {
        name: "conversion", 
        title: "Conversion Summary", 
        metric1Name: "Conversion Rate (Today)",
        metric1Val: "1.3%",
        metric2Name: "Revenue Generated (Today)",
        metric2Val: "$167",
        dataSource: "Flow"

    },
    Campaign: {
        name: "conversion", 
        title: "Campaign Summary", 
        metric1Name: "Emails Sent", 
        metric1Val: "4.72k",
        metric2Name: "Emails Opened",
        metric2Val: "3.25k",
        dataSource: "Something"
    },
    // Add more types as needed
};

export default FlowType;
